/**
 * @desc: 受理发行
 * @created: 2020/4/16
 * @author:yeungyifan
 * @version : v1.0
 */
import request from '@/plugins/http'
import qs from 'qs';

// 列表
export const getListData = params => {
  return request.get('/supplier/list/publish', params)
}

// 查看详情
export const fetchDetails = params => {
  return request.get(`/supplier/${params.id}`, params)
}

// 发行 保存操作
export const publish = data => {
  return request.post(`/supplier/publish`, qs.stringify(data))
}
